import { Button } from '@/shared/ui';
import ValidAddressFromFormikValues from './ValidAddressFormikValues';
import { ExtendedAddress } from '../types';

export const AddressTemplate = ({
    address,
    loading,
    onEdit,
    onGoBack,
    onSubmit,
    defaultAddressValid,
    tryAgainHandler
}: {
    address: ExtendedAddress;
    loading?: boolean;
    defaultAddressValid?: boolean;
    onGoBack?: () => void;
    onEdit?: () => void;
    onSubmit?: () => void;
    tryAgainHandler?: () => void;
}) => {
    return (
        <div className="flex-col font-atkinsonHyperlegible text-sm md:text-base">
            <h3 className="onboarding-section-title md:onboarding-section-title-lg w-full text-left">
                {`${defaultAddressValid ? 'Shipping address' : 'Here is what we found. Is this correct?'}`}
            </h3>
            {address && <ValidAddressFromFormikValues hasEdit={defaultAddressValid} values={address} onEditPressed={onEdit} />}
            <Button
                className="about_you__address__continue_btn"
                type="submit"
                sx={{
                    width: '100%',
                    fontSize: '1.125rem',
                    marginTop: '1.56rem'
                }}
                onClick={onSubmit}
                showEndIcon
                loading={loading}
                testId="button-address-template-continue"
            >
                <span>{`${defaultAddressValid ? 'Continue' : 'Yes, use this address'}`}</span>
            </Button>
            <Button
                type="submit"
                sx={{
                    width: '100%',
                    fontSize: '1.125rem'
                }}
                className="about_you__address__back_btn mb-[1.25rem] mt-[1.25rem] w-full md-max:mb-[0.44rem] md-max:mt-[0.44rem]"
                variant="outlined"
                disabled={loading}
                onClick={defaultAddressValid ? onGoBack : tryAgainHandler}
                testId="button-address-template-back"
            >
                <span>{`${!defaultAddressValid ? 'Try again' : 'Back'}`}</span>
            </Button>
        </div>
    );
};
